<template>
  <AppLayout>
    <div class="col-12 layout-spacing">
      <div class="widget widget-six">
        <zestawieniaMenu></zestawieniaMenu>

        <div class="widget-heading d-flex justify-content-between align-items-center">
          <h4 class="my-0">Telefony</h4>
		  <div class="d-flex gap-2">
            <button class="btn btn-success" @click="openAddModal">
              <i class="bi bi-plus-lg"></i> Dodaj
            </button>
            <a :href="route('kadry.pracownicy.telefony.pdf')" class="btn btn-info" target="_blank">
              <i class="bi bi-file-earmark-pdf"></i>&nbsp;Lista w PDF
            </a>
		  </div>
		</div>

        <div class="widget-content">
          <div class="table-responsive w-100">
            <table class="table table-bordered table-hover text-center">
              <thead>
                <tr>
                  <th @click="sortBy('userName')" class="bg-gray-100 text-start" style="cursor:pointer">
                    Nazwisko i imię
                    <span v-if="sortKey === 'userName'">{{ sortOrder === 'asc' ? '▲' : '▼' }}</span>
                  </th>
                  <th @click="sortBy('nr_telefonu')" class="bg-gray-100 text-start" style="cursor:pointer">
                    Numer telefonu
                    <span v-if="sortKey === 'nr_telefonu'">{{ sortOrder === 'asc' ? '▲' : '▼' }}</span>
                  </th>
                  <th @click="sortBy('model')" class="bg-gray-100 text-start" style="cursor:pointer">
                    Model
                    <span v-if="sortKey === 'model'">{{ sortOrder === 'asc' ? '▲' : '▼' }}</span>
                  </th>
                  <th @click="sortBy('od_kiedy')" class="bg-gray-100 text-start" style="cursor:pointer">
                    Od kiedy
                    <span v-if="sortKey === 'od_kiedy'">{{ sortOrder === 'asc' ? '▲' : '▼' }}</span>
                  </th>
                  <th @click="sortBy('abonament')" class="bg-gray-100 text-start" style="cursor:pointer">
                    Abonament
                    <span v-if="sortKey === 'abonament'">{{ sortOrder === 'asc' ? '▲' : '▼' }}</span>
                  </th>
                  <th class="bg-gray-100">Opcje</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="telefon in sortedTelefony" :key="telefon.id">
                  <td class="text-start">{{ telefon.userName }}</td>
                  <td class="text-start">{{ telefon.nr_telefonu }}</td>
                  <td class="text-start">{{ telefon.model }}</td>
                  <td class="text-start">{{ telefon.od_kiedy }}</td>
                  <td class="text-start">{{ telefon.abonament }}</td>
                  <td>
                    <button class="btn btn-sm btn-primary me-1" @click="openEditModal(telefon)">Edytuj</button>
                    <button class="btn btn-sm btn-danger" @click="deleteTelefon(telefon.id)">Usuń</button>
                  </td>
                </tr>
              </tbody>
			  <tfoot>
  <tr>
    <td class="text-start" colspan="4"><strong>Razem</strong></td>
    <td class="text-start"><strong>{{ totalAbonament }}</strong></td>
    <td></td>
  </tr>
</tfoot>
            </table>
          </div>
        </div>

        <!-- Modal -->
        <div v-if="isModalOpen" class="modal fade show" tabindex="-1" style="display: block; background-color: rgba(0,0,0,0.5)">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">{{ isEditing ? 'Edytuj telefon' : 'Dodaj telefon' }}</h5>
                <button type="button" class="btn-close" @click="closeModal"></button>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-md-6">
                    <label class="form-label">Pracownik</label>
					<select v-model="form.user_id" class="select2 form-select w-100" id="sel_user_id">
					  <option v-for="user in users" :key="user.id" :value="user.id">
						{{ user.last_name }} {{ user.first_name }}
					  </option>
					</select>
                  </div>
                  <div class="col-md-6">
                    <label class="form-label">Numer telefonu</label>
                    <input v-model="form.nr_telefonu" type="text"  @input="onlyDigits" class="form-control" />
                  </div>
                  <div class="col-md-6 mt-3">
                    <label class="form-label">Model</label>
                    <input v-model="form.model" type="text" class="form-control" />
                  </div>
                  <div class="col-md-6 mt-3">
                    <label class="form-label">Od kiedy</label>
                    <input v-model="form.od_kiedy" type="date" class="form-control" />
                  </div>
                  <div class="col-md-6 mt-3">
                    <label class="form-label">Abonament</label>
                    <input v-model="form.abonament"  type="number" step="0.01" class="form-control" />
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button class="btn btn-secondary" @click="closeModal">Anuluj</button>
                <button class="btn btn-success" @click="saveTelefon">{{ isEditing ? 'Zapisz zmiany' : 'Dodaj' }}</button>
              </div>
            </div>
          </div>
        </div>
        <!-- Koniec modal -->
      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import zestawieniaMenu from "@/Pages/Kadry/parts/zestawieniaMenu.vue";
import axios from "axios";

export default {
  components: { AppLayout, zestawieniaMenu },
  props: {
    telefony: { type: Array, required: true },
    users: { type: Array, required: true },
  },
  data() {
    return {
      sortKey: "userName",
      sortOrder: "asc",
      isModalOpen: false,
      isEditing: false,
      form: {
        id: null,
        user_id: null,
        nr_telefonu: "",
        model: "",
        od_kiedy: "",
        abonament: "",
      },
      localTelefony: [],
    };
  },
  computed: {
    sortedTelefony() {
      return this.localTelefony.slice().sort((a, b) => {
        let aVal = a[this.sortKey];
        let bVal = b[this.sortKey];
        if (typeof aVal === "string") {
          aVal = aVal.toLowerCase();
          bVal = bVal.toLowerCase();
        }
        if (aVal < bVal) return this.sortOrder === "asc" ? -1 : 1;
        if (aVal > bVal) return this.sortOrder === "asc" ? 1 : -1;
        return 0;
      });
    },
	 totalAbonament() {
    return this.localTelefony.reduce((sum, t) => {
      const value = parseFloat(t.abonament); // zamiana string -> number
      return sum + (isNaN(value) ? 0 : value);
    }, 0).toFixed(2); // 2 miejsca po przecinku
  },
  },
  mounted() {
    this.localTelefony = this.telefony.map(t => ({ ...t }));
  },
  methods: {
   onlyDigits(event) {
    let value = event.target.value;
    value = value.replace(/[^0-9]/g, '');
    this.form.nr_telefonu = value;
  },

	initUserSelect() {
	  this.$nextTick(() => {
		if ($('#sel_user_id').hasClass("select2-hidden-accessible")) {
		  $('#sel_user_id').select2('destroy');
		}

		$('#sel_user_id')
		  .select2({
			dropdownParent: $('.modal')
		  })
		  .val(this.form.user_id || '')  // ustawienie domyślnej wartości
		  .trigger('change')
		  .on('select2:select', (e) => {
			const selectedUserId = parseInt(e.params.data.id);
			this.form.user_id = selectedUserId;

			// ustaw numer telefonu jeśli istnieje w users
			const user = this.users.find(u => u.id === selectedUserId);
			if (user && user.phone) {
			  this.form.nr_telefonu = user.phone;
			} else {
			  this.form.nr_telefonu = ''; // jeśli brak telefonu
			}
		  });
	  });
	},
    sortBy(key) {
      if (this.sortKey === key) this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
      else this.sortKey = key;
    },
    openAddModal() {
      this.isEditing = false;
      this.form = { id: null, user_id: null, nr_telefonu: "", model: "", od_kiedy: "", abonament: "" };
      this.isModalOpen = true;
	  this.initUserSelect();
    },
openEditModal(telefon) {
  this.isEditing = true;
  this.form = {
    id: telefon.id,                // <- kluczowe, żeby PUT działał
    user_id: Number(telefon.user_id),
    nr_telefonu: telefon.nr_telefonu,
    model: telefon.model,
    od_kiedy: telefon.od_kiedy,
    abonament: telefon.abonament,
  };

  this.isModalOpen = true;

  this.$nextTick(() => {
    if ($('#sel_user_id').hasClass("select2-hidden-accessible")) {
      $('#sel_user_id').select2('destroy');
    }
    $('#sel_user_id')
      .select2({
        dropdownParent: $('.modal'),
      })
      .val(this.form.user_id) // ustawiamy domyślną wartość
      .trigger('change')       // odświeżenie Select2
      .on('select2:select', (e) => {
        const selectedUserId = parseInt(e.params.data.id);
        this.form.user_id = selectedUserId;

        // ustaw numer telefonu jeśli istnieje w users
        const user = this.users.find(u => u.id === selectedUserId);
        if (user && user.phone) {
          this.form.nr_telefonu = user.phone;
        }
      });
  });
},
    closeModal() {
      this.isModalOpen = false;
    },
async saveTelefon() {
  try {
    if (this.isEditing) {
      await axios.put(`/kadry/pracownicy/telefony/update/${this.form.id}`, this.form);
      const index = this.localTelefony.findIndex(t => t.id === this.form.id);
      const user = this.users.find(u => u.id === this.form.user_id);
      this.localTelefony[index] = { ...this.form, userName: `${user.first_name} ${user.last_name}` };
    } else {
      const res = await axios.post('/kadry/pracownicy/telefony/add', this.form);
      const user = this.users.find(u => u.id === this.form.user_id);

      // ustawiamy ID nowego rekordu w formie, żeby od razu można edytować
      this.form.id = res.data.id;
     this.form.nr_telefonu = res.data.nr_telefonu;

      this.localTelefony.push({
        id: res.data.id,
        user_id: this.form.user_id,
        userName: `${user.first_name} ${user.last_name}`,
        nr_telefonu: res.data.nr_telefonu,
        model: this.form.model,
        od_kiedy: this.form.od_kiedy,
        abonament: this.form.abonament,
      });
    }

    this.closeModal();
    this.showToast('success', 'Zapisano', 'Dane zostały zaktualizowane.');
  } catch (error) {
    console.error(error);
    this.showToast('error', 'Błąd', 'Nie udało się zapisać danych.');
  }
},
    async deleteTelefon(id) {
      if (!confirm("Na pewno chcesz usunąć ten telefon?")) return;
      try {
        await axios.delete(`/kadry/pracownicy/telefony/del/${id}`);
        this.localTelefony = this.localTelefony.filter(t => t.id !== id);
		this.showToast('success', 'Usunięto', 'Dane zostały usunięte.');
      } catch (error) {
        console.error(error);
        this.showToast('error', 'Błąd', 'Nie udało się usunąć danych.');
      }
    },
	    showToast(icon, title, message) {
      Toast.fire({
        position: 'top-end',
        toast: true,
        icon: icon,
        title: title,
        html: message,
        showClass: {popup: 'animate__animated animate__fadeInDown'},
        hideClass: {popup: 'animate__animated animate__fadeOutUp'},
        timer: 1500,
        timerProgressBar: true,
        showConfirmButton: false,
        showCloseButton: true
      });
    }

  },
};
</script>

<style scoped>
table th,
table td {
  min-width: 50px;
  height: 32px;
  text-align: center;
}
.bg-gray-100 {
  background-color: #f5f5f5;
  color: black;
}
.text-start {
  text-align: left;
}
</style>